// extracted by mini-css-extract-plugin
module.exports = {"itemLink":"_cf42cc53","image":"_571e2261"};